import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { LocaleProvider } from './i18n/LocaleProvider';
import { EnvironmentProvider } from './shell/EnvironmentProvider';
import { RenderFaultBoundary } from './components/RenderFaultBoundary';
/*
 * THE TYPEFACE, FIRST. Self-hosted Heebo, the face the approved prototypes are drawn in, under
 * the SIL Open Font License 1.1. `fonts.css` carries the licence reasoning; the licence text
 * itself ships at `/licenses/heebo-OFL.txt` and About System links to it.
 */
import './fonts.css';
import './styles.css';
/*
 * THE APPROVED LAYOUT, AFTER the product's own stylesheet so its rules win where the two meet.
 * It is a separate file on purpose: it is an ADAPTATION of a supplied artifact, and keeping it
 * whole is what lets it be diffed against the kit it came from.
 */
import './approved-shell.css';

const host = document.getElementById('root');
if (host === null) throw new Error('#root missing from index.html');

createRoot(host).render(
  <StrictMode>
    <BrowserRouter>
      {/*
        THE BOUNDARY IS INSIDE THE ROUTER AND AROUND THE WHOLE APP.

        Inside, so a fault thrown while rendering a route still has the router above it and the
        address stays what the user typed. Around the whole app, so there is no part of the tree
        whose failure is still a blank page — which is what every part of it was until now.

        It renders only the generic state the product already defines, and it is not a licence to
        let screens throw: a fault reaching here is a defect, and `RenderFaultBoundary.tsx` says so.
      */}
      <RenderFaultBoundary>
        {/*
          LANGUAGE OUTSIDE ENVIRONMENT, and both outside the app: the ribbon needs a translated
          label, and every screen needs the language, so neither may sit inside a route.
        */}
        <LocaleProvider>
          <EnvironmentProvider>
            <App />
          </EnvironmentProvider>
        </LocaleProvider>
      </RenderFaultBoundary>
    </BrowserRouter>
  </StrictMode>,
);
